import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';

import 'antd/dist/antd.less';
import './i18n';

import { store } from './store';
import App from './App';
import onError from './errorsHandler';
import { DirectionProvider } from './hooks/useDirection';

export const history = createBrowserHistory();
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      onError,
    },
    mutations: {
      onError,
    },
  },
});

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <DirectionProvider>
        <QueryClientProvider client={queryClient}>
          <Router history={history}>
            <App />
          </Router>
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </DirectionProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);
